/**
 * True while a forced sign-out (session superseded by a login on another device,
 * dead refresh token, unresolvable identity) is under way, until a new session
 * starts. Requests already in flight fail during that window; their error paths
 * read this to stay quiet so a generic "issue saving your layout" toast does not
 * replace the real reason on the way to /login.
 *
 * Written only by services/api/auth-fetch.ts; it lives outside services/api so
 * feature code can read it (auth-fetch itself is import-restricted).
 */
let ending = false

export function isSessionEnding(): boolean {
  return ending
}

export function setSessionEnding(value: boolean): void {
  ending = value
}
